const props = {
    maptiler_token: process.env.REACT_APP_MAPTILER_TOKEN,
    spring_server_url: process.env.REACT_APP_SPRING_URL,
    flask_server_url: process.env.REACT_APP_FLASK_URL
}

export default props;